/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Pagination from "../../faetures/pagination";
import { getBlogsByPagination } from "../../redux/actions/frontendActions/blogActions";
import DashboardItemCard from "../utils/DashboardItemCard";
import Dashboard_top_header from "../utils/Dashboard_top_header";
import HeaderSearchbar from "../utils/HeaderSearchbar";
import Sidebar from "../utils/Sidebar";
function DashboardAllBlog() {
  const dispatch = useDispatch();
  const { currentPage } = useParams();

  const [sidebarHide, setSidebarHide] = useState(false);
  const handleSidebarHideAndShow = (e) => {
    setSidebarHide(!sidebarHide);
  };

  const {allblogs ,parPage,blogCount , blogSuccessMessage}=useSelector(state => state.Blog);

  useEffect(() => {
    dispatch(getBlogsByPagination(currentPage ? currentPage.split("-")[1] : 1));
    if(blogSuccessMessage){
      toast.success(blogSuccessMessage);
      window.location.reload();
    }
  }, [currentPage , blogSuccessMessage]);
  
  return (
    <div className="dashboard-container">
         <Toaster position={'bottom-center'}
                reverseOrder={false}
                toastOptions={
                    {
                        style: {
                            fontSize: '15px'
                        }
                    }
                }
            />
      <div className="navbar-area">
        <Dashboard_top_header
          handleSidebarHideAndShow={handleSidebarHideAndShow}
          sidebarHide={sidebarHide}
        />
      </div>

      <div className="dashboard-main-flex">
        <div className="dashboard-sidebar">
          <Sidebar sidebarHide={sidebarHide} />
        </div>
        <div className="dashboard-item">
          <HeaderSearchbar page="Blog" placeholder="Search blog" />

          <div className="dashboard-items-grid">
      {
        allblogs.length> 0 ? allblogs.map((blog , index) => <DashboardItemCard blog={blog} index={index} /> ) : <h1>Loading...</h1>
      }
     
          


          </div>
          <div className="pagination-area">
            <Pagination
              pageNumber={currentPage ? currentPage.split("-")[1] : 1}
              perPage={parPage}
              itemCount={blogCount}
              path="/admin/dashboard/all-blog"
            />
            </div>
        </div>
   
      </div>
   
    </div>
  );
}

export default DashboardAllBlog;
